import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { Task } from '../../../types/Task';

export const fetchTask = async (uuid: string | undefined, template: string | undefined) => {
  if (uuid === undefined) return null;
  
  const config = template ? { params: { template } } : {};
  const response = await CustomAxios.get<Task>(`tasks/${uuid}`, config);
  const { data } = response;
  return data;
};

interface UseGetTaskByIdProps {
  uuid?: string;
  template?: string,
}

export function useGetTaskById({ uuid, template }: UseGetTaskByIdProps) {
  const query = useQuery({
    queryKey: [queryKeys.allTasks, uuid],
    queryFn: () => fetchTask(uuid, template)
  });

  return query;
}
